import type { JSX } from 'react';

import { JsonLd } from './jsonld';

export type FaqJsonLdQuestionEntry = Readonly<{
  name: string;
  text: string;
}>;

type FaqJsonLdProps = {
  keyOverride?: string;
  questions: readonly FaqJsonLdQuestionEntry[];
};

const FaqJsonLd = ({
  keyOverride,
  questions,
}: FaqJsonLdProps): JSX.Element | null => {
  if (!questions.length) {
    return null;
  }

  const mainEntity = questions.map(question => ({
    '@type': 'Question' as const,
    acceptedAnswer: {
      '@type': 'Answer' as const,
      text: question.text,
    },
    name: question.name,
  }));

  return (
    <JsonLd
      keyOverride={keyOverride}
      mainEntity={mainEntity}
      scriptKey="faq"
      type="FAQPage"
    />
  );
};

export default FaqJsonLd;
